import { isNil } from "lodash";
import { Input } from "./Input";
import { RADIO_STATES, Radio } from "./Radio";
import styles from "./scrutinyTrack.module.scss";
import classnames from "classnames/bind";

const classNameBuilder = classnames.bind(styles);

export const ScrutinyTrack = ({ value, setValue, presentation }) => {
  const topValue = isNil(value?.top) ? RADIO_STATES.EMPTY : value?.top;
  const bottomValue = isNil(value?.bottom) ? RADIO_STATES.EMPTY : value?.bottom;

  return (
    <div className={"container"}>
      <div className={styles["row"]}>
        <div className={styles["top"]}>
          <div className={styles["left-stick"]} />
          <div className={styles["diagonal-container"]}>
            <div className={styles["diagonal-stick"]} />
          </div>
          <Radio
            value={topValue}
            colorless
            states={[
              RADIO_STATES.EMPTY,
              RADIO_STATES.MARKED,
              RADIO_STATES.BURNED,
            ]}
            onClick={(e, nextValue) =>
              setValue((prev) => ({ ...prev, top: nextValue }))
            }
            className={styles["radio"]}
          />
        </div>
        <Input
          className={styles["input"]}
          placeholder={presentation ? "" : "From Above"}
          value={value?.topLabel || ""}
          onChange={(e) =>
            setValue((prev) => ({ ...prev, topLabel: e.target.value }))
          }
          presentation={presentation}
        />
      </div>
      <div className={styles["row"]}>
        <div className={styles["bottom"]}>
          <div className={styles["diagonal-container"]}>
            <div className={styles["diagonal-stick"]} />
          </div>
          <Radio
            value={bottomValue}
            colorless
            states={[
              RADIO_STATES.EMPTY,
              RADIO_STATES.MARKED,
              RADIO_STATES.BURNED,
            ]}
            onClick={(e, nextValue) =>
              setValue((prev) => ({ ...prev, bottom: nextValue }))
            }
          />
        </div>
        <Input
          className={classNameBuilder("input", "pad")}
          placeholder={presentation ? "" : "From Below"}
          value={value?.bottomLabel || ""}
          onChange={(e) =>
            setValue((prev) => ({ ...prev, bottomLabel: e.target.value }))
          }
          presentation={presentation}
        />
      </div>
    </div>
  );
};
